import { sliderMediaBreakPoints } from '@helpers/utils.js';
import CommonFields from '../fields/commonFields';

const {
  i18n: { __ },
  components: { PanelBody, ToggleControl },
} = wp;

const CommonSettings = ({
  tabNavSliderSettings,
  tabContentSliderSettings,
  setSliderSettingAttribute,
  tabContents,
  removeSliderSettingAttribute,
  enableProgressLine,
  setAttributes,
}) => {
  return (
    <>
      <PanelBody title={__('Common Settings', 'b3rg')} initialOpen={true}>
        <ToggleControl
          checked={enableProgressLine}
          onChange={(value) => {
            setAttributes({ enableProgressLine: value });
          }}
          label={__('Progress Line', 'b3rg')}
        />
        {sliderMediaBreakPoints
          .map((sliderMediaBreakPoint) => {
            const breakPoint = sliderMediaBreakPoint.breakPoint;
            const deviceSlug = sliderMediaBreakPoint.slug;
            return (
              <CommonFields
                key={breakPoint}
                {...{
                  sliderMediaBreakPoint,
                  sliderTabNavSettings: tabNavSliderSettings[deviceSlug],
                  sliderTabContentSettings:
                    tabContentSliderSettings[deviceSlug],
                  slides: tabContents,
                  setSliderSettingAttribute,
                  removeSliderSettingAttribute,
                }}
              />
            );
          })
          .reverse()}
      </PanelBody>
    </>
  );
};

export default CommonSettings;
